export default "__VITE_ASSET__5pWzF1EB__"